import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { getItemPriorityName } from '@models/items.models';
import { TranslatePipe } from '@ngx-translate/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-item-priority-column',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './item-priority-column.component.html',
  styleUrl: './item-priority-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemPriorityColumnComponent implements AgRendererComponent {
  readonly priority = signal('');

  agInit(params: ICellRendererParams): void {
    this.priority.set(getItemPriorityName(params.data.priority) || '');
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
